import React from 'react';
import { Helmet } from 'react-helmet-async';
import styles from './Hero.module.css';

/**
 * Hero — Large landing visual with Pandit figure, glowing halo, gradient, and CTA.
 * SEO-optimized H1, trust indicators, and city mentions.
 */

// Sanskrit/spiritual symbols for floating background
const floatingSymbols = ['ॐ', '☸', '🔱', '卐', '☪', '✡', '🪷', '☯'];

export default function Hero({ panditImage, onBookNow }) {
    return (
        <section className={styles.hero}>
            <Helmet>
                <title>PanditJi.space — Book Trusted Pandits for Puja &amp; Hindu Rituals Across India</title>
                <meta name="description" content="Book experienced and verified pandits online for all pujas, havans, weddings, griha pravesh, satyanarayan katha, and Hindu rituals across India." />
                <link rel="canonical" href="https://www.panditji.space/" />
            </Helmet>

            {/* Floating Sanskrit icons */}
            <div className={styles.floatingIcons}>
                {floatingSymbols.map((symbol, i) => (
                    <span key={i} className={styles.floatingIcon}>
                        {symbol}
                    </span>
                ))}
            </div>

            {/* Hero text content */}
            <div className={styles.heroContent}>
                <h1 className={styles.headline}>Book Verified Pandits for Every Puja &amp; Hindu Ritual</h1>
                <p className={styles.subtext}>Sacred Wisdom,<br />Modern Access.</p>
                <p className={styles.tagline}>
                    Your trusted online pandit service for marriage, griha pravesh, havan, and all Hindu ceremonies.
                    Book verified pandits across Mumbai, Delhi, Bangalore, Pune, Hyderabad, Chennai, Kolkata and all of India.
                </p>
                <button className={styles.ctaButton} onClick={onBookNow} id="hero-book-now-btn">
                    Book a Pandit Now
                </button>

                {/* Trust indicators */}
                <div className={styles.trustIndicators}>
                    <div className={styles.trustItem}>
                        <span className={styles.trustNumber}>500+</span>
                        <span className={styles.trustLabel}>Pujas Completed</span>
                    </div>
                    <div className={styles.trustDivider} />
                    <div className={styles.trustItem}>
                        <span className={styles.trustNumber}>100+</span>
                        <span className={styles.trustLabel}>Verified Pandits</span>
                    </div>
                    <div className={styles.trustDivider} />
                    <div className={styles.trustItem}>
                        <span className={styles.trustNumber}>🇮🇳</span>
                        <span className={styles.trustLabel}>All Across India</span>
                    </div>
                </div>
            </div>

            {/* Pandit figure with halo */}
            <div className={styles.panditContainer}>
                <div className={styles.haloGlow} />
                <img
                    src={panditImage}
                    alt="Verified pandit performing Hindu puja ceremony — book a pandit online at PanditJi.space"
                    className={styles.panditImage}
                    loading="eager"
                />
            </div>

            {/* Bottom gradient fade */}
            <div className={styles.bottomGradient} />
        </section>
    );
}
